import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Mic, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useLang } from "@/i18n";
import VoiceRecorderPanel from "./VoiceRecorderPanel";

export default function QuickVoiceNote() {
  const { tf } = useLang();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          className="h-10 w-10 md:h-9 md:w-9 flex items-center justify-center rounded-lg text-muted-foreground hover:text-foreground hover:bg-secondary/60 transition-colors data-[state=open]:text-athlynx data-[state=open]:bg-athlynx/10"
          aria-label={tf("Enregistrer une note vocale")}
          title={tf("Enregistrer une note vocale")}
          data-testid="topbar-voice-btn"
        >
          <Mic className="h-4 w-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" sideOffset={8}
        className="w-[min(380px,calc(100vw-24px))] p-4 max-h-[80vh] overflow-y-auto"
        data-testid="quick-voice-panel">
        <div className="flex items-start justify-between gap-2 mb-3">
          <div>
            <div className="text-sm font-semibold flex items-center gap-2">
              <Mic className="h-3.5 w-3.5 text-athlynx" /> {tf("Note vocale rapide")}
            </div>
            <p className="text-xs text-muted-foreground mt-0.5">{tf("Enregistrez une note et associez-la à un athlète.")}</p>
          </div>
          <button onClick={() => setOpen(false)} className="h-7 w-7 rounded-md flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-secondary/60"
            aria-label={tf("Fermer")} data-testid="quick-voice-close">
            <X className="h-4 w-4" />
          </button>
        </div>
        <VoiceRecorderPanel
          onClose={() => setOpen(false)}
          onSaved={(pid) => { setOpen(false); navigate(`/players/${pid}?tab=notes`); }}
        />
      </PopoverContent>
    </Popover>
  );
}
